export default {"src":"/_next/static/media/de.9280e9c5.svg","height":1122,"width":478,"blurWidth":0,"blurHeight":0};